"use strict";

module.exports = {
    "user2": {
        "add-account": "Yeni hesap ekle",
        "edit-accounts": "Listeyi düzenle",
        "enter": "Giriş yap",
        "exit": "Çıkış",
        "help": "Yardım",
        "mail": function(params) {
            var plural = require('/place/sandbox-data/tasks/5/5/2529492855/mounted_arcadia/commerce/adv-front/node_modules/webpack-bem-i18n-loader/plural/tr.js');
            return plural({
                count: params.count,
                one: 'yeni e-posta',
                some: 'yeni e-posta',
                many: 'yeni e-posta',
                none: 'Yeni e-posta yok'
            });
        },
        "mail_compose": "E-posta yaz",
        "passport": "Hesap yönetimi",
        "settings": "Ayarlar",
        "upload_files": "Diskim",
        "ya_plus": "Yandex.Plus edinin",
        "ya_plus_on": "Yandex.Plus"
    }
};